// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-marker-popup-header {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey45);
  color: var(--grey45);
  word-spacing: 3px;
}

.map-marker-popup-title {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey71);
  color: var(--grey71);
  padding-right: 7px;
}

.map-marker-popup-value {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: right;
  color: var(--grey45);
  color: var(--grey45);
}

.map-polygon-tooltip {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.88;
  letter-spacing: normal;
  text-align: left;
  color: var(--grey45) !important;
  color: var(--grey45) !important;
}

.marker-cluster-small {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}
.marker-cluster-small div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}

.marker-cluster-medium {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}
.marker-cluster-medium div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}

.marker-cluster-large {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}

.marker-cluster-large div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
}

/* IE 6-8 fallback colors */
.leaflet-oldie .marker-cluster-small {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}
.leaflet-oldie .marker-cluster-small div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}

.leaflet-oldie .marker-cluster-medium {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}
.leaflet-oldie .marker-cluster-medium div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}

.leaflet-oldie .marker-cluster-large {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}
.leaflet-oldie .marker-cluster-large div {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: rgb(238, 241, 246);
}

/*:has working in all browsers except firefox*/
.leaflet-right:has(span) {
  width: 100%;
}

#toggle-handle {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 12px;
  height: 12px;
  left: 2px;
  top: calc(50% - 12px / 2);
  background: #ffffff;
  box-shadow:
    0px 0px 3px rgba(64, 69, 79, 0.07),
    0px 1px 1px rgba(64, 69, 79, 0.3);
  border-radius: 40px;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

#toggle-handle.on {
  transform: translateX(100%);
}

#toggle-switch {
  position: relative;
  width: 28px;
  height: 16px;
  border-radius: 80px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.map-legend {
  font-family: 'Source Sans Pro', sans-serif;
}

/*#toggle-switch:hover {*/
/*  background-color: #6a7ebf;*/
/*}*/

/*#toggle-switch:active {*/
/*  background-color: #3c4d88;*/
/*}*/

.marker-cluster {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  background-color: var(--grey96);
  background-color: var(--grey96);
  background-clip: padding-box;
  border-radius: 18px;
  padding: 0px !important;
  margin: 0px !important;
  line-height: 1.7;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--grey45);
  color: var(--grey45);
}
/*
.marker-cluster div {

  /* font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--grey45);

	} */
`, "",{"version":3,"sources":["webpack://./app/styles/markers.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EAApB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EAApB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;AACjC;;AAEA,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA,8CAA8C;AAC9C;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB;;qCAEmC;EACnC,mBAAmB;EACnB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,yBAAyB;AACzB,+BAA+B;AAC/B,IAAI;;AAEJ,0BAA0B;AAC1B,+BAA+B;AAC/B,IAAI;;AAEJ;EACE,0CAA0C;EAC1C,+BAA+B;EAA/B,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EAApB,oBAAoB;AACtB;AACA;;;;;;;;;;;;IAYI","sourcesContent":[".map-marker-popup-header {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey45);\n  word-spacing: 3px;\n}\n\n.map-marker-popup-title {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey71);\n  padding-right: 7px;\n}\n\n.map-marker-popup-value {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.6;\n  letter-spacing: normal;\n  text-align: right;\n  color: var(--grey45);\n}\n\n.map-polygon-tooltip {\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: 1.88;\n  letter-spacing: normal;\n  text-align: left;\n  color: var(--grey45) !important;\n}\n\n.marker-cluster-small {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n.marker-cluster-small div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n\n.marker-cluster-medium {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n.marker-cluster-medium div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n\n.marker-cluster-large {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n\n.marker-cluster-large div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n}\n\n/* IE 6-8 fallback colors */\n.leaflet-oldie .marker-cluster-small {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n.leaflet-oldie .marker-cluster-small div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n\n.leaflet-oldie .marker-cluster-medium {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n.leaflet-oldie .marker-cluster-medium div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n\n.leaflet-oldie .marker-cluster-large {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n.leaflet-oldie .marker-cluster-large div {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: rgb(238, 241, 246);\n}\n\n/*:has working in all browsers except firefox*/\n.leaflet-right:has(span) {\n  width: 100%;\n}\n\n#toggle-handle {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 12px;\n  height: 12px;\n  left: 2px;\n  top: calc(50% - 12px / 2);\n  background: #ffffff;\n  box-shadow:\n    0px 0px 3px rgba(64, 69, 79, 0.07),\n    0px 1px 1px rgba(64, 69, 79, 0.3);\n  border-radius: 40px;\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n}\n\n#toggle-handle.on {\n  transform: translateX(100%);\n}\n\n#toggle-switch {\n  position: relative;\n  width: 28px;\n  height: 16px;\n  border-radius: 80px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.map-legend {\n  font-family: 'Source Sans Pro', sans-serif;\n}\n\n/*#toggle-switch:hover {*/\n/*  background-color: #6a7ebf;*/\n/*}*/\n\n/*#toggle-switch:active {*/\n/*  background-color: #3c4d88;*/\n/*}*/\n\n.marker-cluster {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);\n  background-color: var(--grey96);\n  background-clip: padding-box;\n  border-radius: 18px;\n  padding: 0px !important;\n  margin: 0px !important;\n  line-height: 1.7;\n  font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: var(--grey45);\n}\n/*\n.marker-cluster div {\n\n  /* font-family: 'Source Sans Pro', sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  font-style: normal;\n  font-stretch: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: var(--grey45);\n\n\t} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
